var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRateActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.2332 0.908447H2.43321C1.31654 0.908447 0.408203 1.81677 0.408203 2.93344V5.73343C0.408203 6.8501 1.31654 7.75842 2.43321 7.75842H5.2332C6.34986 7.75842 7.2582 6.8501 7.2582 5.73343V2.93344C7.2582 1.81677 6.34986 0.908447 5.2332 0.908447Z",
    fill: "#7066FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.5667 0.908447H10.7667C9.65004 0.908447 8.7417 1.81677 8.7417 2.93344V5.73343C8.7417 6.8501 9.65004 7.75842 10.7667 7.75842H13.5667C14.6834 7.75842 15.5917 6.8501 15.5917 5.73343V2.93344C15.5917 1.81677 14.6834 0.908447 13.5667 0.908447Z",
    fill: "#7066FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.2332 9.2417H2.43321C1.31654 9.2417 0.408203 10.15 0.408203 11.2667V14.0667C0.408203 15.1833 1.31654 16.0917 2.43321 16.0917H5.2332C6.34986 16.0917 7.2582 15.1833 7.2582 14.0667V11.2667C7.2582 10.15 6.34986 9.2417 5.2332 9.2417Z",
    fill: "#7066FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.5667 9.2417H10.7667C9.65004 9.2417 8.7417 10.15 8.7417 11.2667V14.0667C8.7417 15.1833 9.65004 16.0917 10.7667 16.0917H13.5667C14.6834 16.0917 15.5917 15.1833 15.5917 14.0667V11.2667C15.5917 10.15 14.6834 9.2417 13.5667 9.2417Z",
    fill: "#7066FF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRateActive);
export default __webpack_public_path__ + "static/media/rate_active.c17cd20aac310dc2f087b8954c44b2d4.svg";
export { ForwardRef as ReactComponent };